import "../chunk-D57E6H3M.mjs";

// src/hooks/LoadingActivityProvider.tsx
import { use, useRef } from "react";
import { LoadingActivityContext } from "./useLoadingActivity.mjs";
import { jsx } from "react/jsx-runtime";
function LoadingActivityProvider({ onActiveChange, children }) {
  const count = useRef(0);
  const active = useRef(false);
  const onChange = useRef(onActiveChange);
  onChange.current = onActiveChange;
  const report = useRef(() => {
    count.current++;
    if (!active.current) {
      active.current = true;
      onChange.current(true);
    }
    let reported = true;
    return () => {
      if (!reported) return;
      reported = false;
      count.current--;
      queueMicrotask(() => {
        if (count.current === 0 && active.current) {
          active.current = false;
          onChange.current(false);
        }
      });
    };
  });
  return /* @__PURE__ */ jsx(LoadingActivityContext, { value: report.current, children });
}
function LoadingActivityMute({ muted = true, children }) {
  const report = use(LoadingActivityContext);
  return /* @__PURE__ */ jsx(LoadingActivityContext, { value: muted ? null : report, children });
}
export {
  LoadingActivityMute,
  LoadingActivityProvider
};
//# sourceMappingURL=LoadingActivityProvider.mjs.map